import './App.css';
import DemoApp from './components/demo/DemoApp'


function App() {
  return (
    <div className="App">
      {/* <Counter /> */}
      <DemoApp />
    </div>
  );
}

export default App;
